///// NOTE: MAKE SURE THERE ARE NO DUPE FIELDS!  IT CAUSES WEIRD MODULE LOADING ERRORS!
/////


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DATA BASE FIELD DEFINITIONS (FOR APPSCRIPT XLS GENERATION)
//       - field value code
//             - 0 to 999:  User supplied
//             - 1000+:  Auto generated
//             - *0:  Optional, can be blank
//             - *1:  Required, can not be blank
//             - *2:  Required and TYPED, can not be blank and in defined set
//             - *3:  Required and UNIQUE, can not be blank or have duplicate in org (e.g. )
//             - *4:  Required and PREDEFINED, can not be blank and sys will verify, already defined in another table
//             - *5:  Immutable, Required, Unique, must be unique, and can't change after it's set!

//
//  HIGH LEVEL DB RELATIONSHIPS:
//    @RUNTIME: Org => Program => Sequence => Drills
//    @BROWSE:  Vendor => Section => Drills
//    @GROUP:  Org => [ Player ]
//    CONTENT:  Org => [ Vendor ] => [ Progrm ] => [ Sequence ] => Drills
//    CONTENT:  Player => [ Org ] => [ Program ] => [ Sequence ]
//
//    STATS:  Player => [ Stats ] => [ Program ] => [ Sequence ]
//
//	key:  human readable handle for easy handling
//	id:  generated human readable hash for debug <org_key>-<player_key>
//	description:  block of text, aps can abstract into summary sheet
//	_id:  firebase id (long random string)
//	__auto__:  seperator in object, tells aps that fields below are machine generated
//

const MASTER_ID = "master:axos:9233";

// membership object for initialization
//     - general mechanism to associate different objects (1-to-1 or 1-to-many)
//     - connects orgs => org [ affiliate ]
//     - connects player => org    [ org ]
//     - connects group => org   [ division ]
//     - connects player => group   [ group ]
//     - connects player => player [ peer ]
//     - connects player => program  [ program ]
//     - auth_key is signed by owner to prevent unthorized db hack
//
const MembershipObj = {
	"owner_hash": 14,		// e.g. player_hash, org_hash, prog_hash
	"child_key": 24,		// e.g. player_key, org_key, prog_key, invite_key=(type+create_date_hash)
	"type": 42,			// types of association: [ org, group, program, user, invite ]
	"subtype": 52,		// subtypes of association: [ one_time,  ]
	"notes": 80,			// for admin
	"state": 100,		// association requiring email confirmation, late bindng
	"expiration": 110,	// when this relationship expires
	"aux1": 120,		// for invite: flow, for xxx: ?
	"aux2": 130,		// 

	"id": 1010,			// firebase ID
	//"child_id": 1024,		// e.g. org_id, master_id
	"created": 1040,		// creation date
	"auth": 2010,		// optional: encrypted member_id by owner private key, if premium
	"org_key": 2020,		// for multi-tenancy query
	"org_id": 2020,		    // creator org ID for audit
	"owner_id": 2030,		// creator ID for audit   [ org_id, user_id ]
	"create_id": 2040,		// creator ID for audit
	"test": 2045,		    // test mode
	"hash": 2050,			// <type>-<owner_hash>-<child_hash>
	"timestamp": 2060,
}

// tiny URL link object for initialization
//	- support short URL redirect to expand out drill_hash (: not allowed on some sites)
//      - One instance for each unique invite and drill
//      - 
//
const LinkObj = {
	// basics
	"invite_key": 21,			// from membership
	"drill_hash": 31,			// hash
	"url": 41,			        // general url
	"type": 61,
	"subtype": 65,			// [ system, test ]  for filtering
	"notes": 70,			// for owner

	"link_id": 1010,			// unique hash of create time with checksum
	"created": 1040,		// creation date
	"org_key": 2020,		// for multi-tenancy query
	"org_id": 2020,		    // creator org ID for audit
	"hash": 2050,			// <type>+<invite_key>-<drill_hash>
	"timestamp": 2060,
}


// content info for initialization
//     - contains multi-media CONTENT info for presentation
//     - holds whatever content the system entities needs, like tutorial, splash page
//     - owned at org level
//     - db-driven way to customize and present content
//     - can contains link and text and be object-specific
//
const ContentObj = {
	// info
	"key": 15,	        //  unique key for this content
	"seq": 31,			// sequence within content block (carosel), 
	//"owner_hash": 35,	//  [ user, prog, org, group, ] ==> only orgs can own content obj (?)
	"type": 42,			// types of info: [ tutorial, notice, reminder ]
    "version": 51,
	"state": 72,		// [ "archived"]
    "language": 210,
    "title": 220,
    "template": 230,     // react component template name
    "text": 240,
    "video": 250,
    "image": 260,       // image URL
    "html": 270,

	"id": 1010,			// firebase ID
	"created": 1020,		// creation date
	"content_hash": 2030,	// <type>-<owner_hash>, share across version
	//"owner_id": 2040,      // for validation
	"org_id": 2044,      // for multi-tenancy, can only below to org...no user owned
	"flow_key": 2050,	    // name of the flow grouping, dup from key - keep it consistent w/ content
	"flow_hash": 2055,	    // name of the flow grouping
	"hash": 2060,			// cont-<type>-<key>-<owner_hash>-<version>
	"timestamp": 2070,

    // lots of fields
}


// program object for initialization
//	- vendor stitch their drills together to create programs
//      - players instantiates from template and coach can customize
//      - program can be modified later, and propagate as update to players
//
const ProgramObj = {
	// basics
	"key": 15,			// easy 4 letter shorthand for admin
	"name": 21,			// human readable title
	"seq": 31,			// sequence within program, orig step by 1000, each add splits it, support 10 adds
	"version": 41,
	"notes": 50,			// for owner
	"type": 62,			    // [ drill, content, holiday, ]
	"subtype": 72,			// [ system, test ]  for filtering
	"level": 111,			// skill level before it's accessible
	"param1": 115,			// param for customizing flows
	"public": 121,			// shows up in search directory
	"tracks": 131,			// simultaneous drill tracks
	"flow_hash": 144,		// <org_key>-<sequence_key> - to replace sequence_hash, coulbe sequence or contents
	//"sequence_hash": 154,		// <org_key>-<sequence_key>/ 

	// details
	"description": 200,

	"id": 1010,			// firebase ID
	"created": 1020,		// creation date
	"org_key": 1030,		// owner of this program
	"org_id": 1040,			// owner of tis program
	"flow_id": 1050,	    // validate
	//"sequence_id": 1060,	// validate
	"hash": 2000,			// <vendor>-<key>-<version>
	"timestamp": 2010,
}


// drill sequences that is the meat of each program
//      - program => sequence => drill
//      - binder layer between program and drills, allow aliasing
//      - a sequence can be used by multiple programs and multiple vendors
//      - Need to validate this org has access to this program_key
//
const MotionObj = {
	// contents
	"key": 15,			// key of this sequence, a seq may be used by multiple programs
	"version": 21,
	"seq": 31,			// sequence within program, orig step by 1000, each add splits it, support 10 adds
	"notes": 50,		// for owner
	"track": 61,		// each track has a queue of drills

	"x": 112,		    // starting x
	"y": 122,			// start y
	"move": 132,			// direction of movement
	"type": 144,		    // [ base, mover ]
	"duration": 151,		// time for this leg

	// if user instantiated
	"user_id": 200,			// if instantiated for a player, null if template

	"id": 1010,			// owner of this sequence
	"created": 1020,		// creation date
	"org_key": 1040,		// owner of this sequence
	"org_id": 1050,			// owner of this sequence
	"motion_hash": 2010,	// <org_key>-<key>-<ver>, MUST BE after org_id
	"hash": 2020,			// <org_key>-<key>-<ver>-<seq>
	"timestamp": 2030,
}


// drill sequences that is the meat of each program
//      - program => sequence => drill
//      - binder layer between program and drills, allow aliasing
//      - a sequence can be used by multiple programs and multiple vendors
//      - Need to validate this org has access to this program_key
//      - IMMUTABLE: ".seq" is fixed to the object, contents may chg
//
const SequenceObj = {
	// contents
	"key": 15,			// key of this sequence, a seq may be used by multiple programs
	"seq": 31,			// IMMUTABLE: sequence within program, orig step by 1000, each add splits it, support 10 adds
	"version": 41,
	"type": 45,         // [program, section, user]
	"hide": 50,			// Used to feed Today, do not display, this means there needs to be sections with dup drills
	"notes": 60,			// for owner
	"state": 70,			// *** CONST: [ 0=untouched, 1=active, 2=abandoned, 5=completed ]

	"action_hash": 120,		// [polyfill] can be drill or section flow
	"track": 131,			// each track has a queue of drills
	//"drill_hash": 114,		// [remove] replace drill_key, drill_ver, owner_key
	//"drill_ver": 124,		// reference to drill version, * will match to latest
	//"owner_key": 200,		// do not need to know drill owner's id (privacy), just key is OK

	// customization
	//"owner_id": 200,		// for sequewnce template AND instantiated player seqs [ org_id, user_id ]
	//"exit_sets": 240,		// how many sets before makred done
	"tot_sets": 211,		// total sets before moving on
	"min_sets": 221,		// minimum sets per day targeted
	"cur_sets": 231,		// current set, if null then use drill count
	"today_cnt": 250,		// sets done today, reset when cross a day
	"last_timestamp": 260,		// last timestamp that crossed a day

	"id": 1010,			// owner of this sequence
	"owner_id": 1015,		// who owns it
	"created": 1020,		// creation date
	"org_key": 1030,		// owner of this sequence       // VERY SENSITIVE SEQUENCE!  org_key on TOP
	"org_id": 1040,			// owner of this sequence
	"section_hash": 1100,	// back line to a section, used by useq only
	"action_id": 1105,		// [polyfill] could be drill_name or section_name, to help humans
	"action_name": 1110,		// [polyfill] could be drill_name or section_name, to help humans
	"action_key": 1130,	    //  [NEED THIS?]  name of the flow grouping, dup from key - keep it consistent w/ content
	"action_flow": 1150,	    //  name of this flow grouping
	"flow_hash": 1150,	    //  name of this flow grouping
	"hash": 2000,			// <org_key>-<sequence_key>
	"timestamp": 2010,

	//"drill_name": 1120,		// to help humans
	//"drill_key": 1124,	// [remove: get it from the drill_hash] reference to drill, must have access to owner vendor, 
	//"drill_hash": 1110,		// firebase ID
	//"sequence_hash": 1140,	// <org_key>-<key>-<ver>, MUST BE after org_id
}


// menu of sections object for initialization
//     - multiple menu records form a set, via the set_key, a set is designed
//     - every user is assigned a menu_hash on start, this drives the app display
//     - each menu can be localized or specialized
//     - a menu loosely couples to  sections via .type, this allows more sections to be added freely
//     - each menu has multiple sections, and each section has multiple drills
//     - an org can use default menu, or create their own
//
const MenuObj = {
	"key": 15,			// easy 4 letter shorthand for admin
	"name": 21,			// human readable title
	"seq": 31,			// sequence within program, orig step by 1000, each add splits it, support 10 adds
	"version": 41,
	"notes": 50,		// for owner
	"type": 62,			// [skill, game, condition, ]  --> "parent" is special sub-menu trigger
	"language": 72,		// [en, es, ch, ]  --> this helps choosing version of section
    "set_key": 82,      // hash that ties the menus into one set
	"parent_hash": 92,	// if set, then this is a sub-menu

	"id": 1010,			// firebase ID
	"created": 1020,		// creation date
	"org_key": 1030,		// browsing section-drill is designed by vendor
	"org_id": 1040,
	"parent_id": 1050,	// validate the menu parent is good
    "menu_hash": 2010,      // <org_key>:<set_key>:<language>   to access the set
	"hash": 2020,			// menu:<org_key>:<set_key>:<key>:<version>
	"timestamp": 2030,
}



// drill secion object for initialization
//     - used to group drills together for browse mode
//     - belong to vendor
//     - a section can be used by multiple menus and drills
//
const SectionObj = {
	"key": 15,			// easy 4 letter shorthand for admin
	"name": 21,			// human readable title
	"seq": 31,			// sequence within program, orig step by 1000, each add splits it, support 10 adds
	"version": 41,
    "flow_hash": 45,    // Drills belonged to this Section is defined in a Sequence
	"notes": 50,			// for owner
	"type": 62,			// [skill, game, condition, ]
	"subtype": 62,			// [system, test, ]   useful tags
	"language": 72,			// [en, es, ch, ]  --> this helps choosing version of section
	"org_key": 84,		// browsing section-drill is designed by vendor

	"id": 1020,			// firebase ID
	"created": 1020,		// creation date
	"org_id": 1030,
	"hash": 2000,		// sct:<org_key>:<key>:<version>
	"timestamp": 2010,
}



// drill object for initialization
//     - each one is something players do repeatedly
//     - the sequence is orchestrated by programs
//
const DrillObj = {
	// basics
	"key": 15,			// easy 4 letter shorthand for admin
	"name": 21,			// human readable title
	"seq": 31,			// sequence within program, orig step by 1000, each add splits it, support 10 adds
	"version": 41,
	"notes": 50,			// for owner
	"type": 62,			// [skill, game, condition, ]
	"subtype": 72,			// [skill, game, condition, ]
	"level": 81,			// skill level
	"public": 91,		// anybody can see

	// meta
	"sets": 111,        // defined per session
	"reps": 121,
	"goals": 142,		// relevant perf goals to collect

    // THIS WILL BE OBSOLETED, USE SEQUENCE INSTEAD!!!
	"section_hash": 134,		// section it belongs to, specified by vendor
	"section_override": 135,	// use to override to hardcode system sections (e.g. review)

    // finger game
	"motion_hash": 220,     // point to motion flow
	"tag": 210,            // arbitrary tag for sorting, NEED TO MOVE UP
	"param1": 230,			// param for customizing flows
	"param2": 240,			//

	// contents
	"icon": 310,		// make it pretty
	"description": 320,	// describe intent of this drill
	"instruction": 330,	// detailed instruction
	"intro_text": 360,
	"intro_video": 370,	// url
	"drill_video": 381,	// url: example video of drill in action
	"width": 390,			// video dimensions
	"height": 400,

	"id": 1010,	
	"created": 1020,		// creation date
	"org_key": 1030,		// owner
	"org_id": 1040,
	"valid_model": 1050,	// id of AI model to validate movement
	"section_id": 1110,		// firebase ID
	"motion_id": 1120,		// firebase ID
	"auth": 1130,			// TBD: THINK THIS OUT
	"hash": 2000,			// <org_key>-<drill_key>-<version>,
	"timestamp": 2010,

    // EXTRA POLY_FIELDS
    // <prg:hash>           // used by a program, defined in its sequence, auto added by backend
    // <sec:hash>           // used by a section, defined in its sequence, auto added by backend
}

// org object for initialization
//     - an org is a CONSUMER of drills, does not own players
//     - example: clubs, school, groups, renegade
//     - an org can also have an org (to produce own drill)
//     - every players need to belong to an org
//     - default org is axos, if does not have a group
//     - make it easy to find local groups
//
const OrgObj = {
	// basics
	"key": 15,			// easy 4 letter shorthand for admin
	"name": 21,			// human readable title
	"notes": 30,			// for owner
	"type": 42,			// [ master, commercial, school, club, group, premium, ]
	"producer": 51,			// producer of content
	"consumer": 61,			// consumer of content, have players
	"public": 71,			// searchable in a directory
	"premium": 81,			// paid service

	// details
	"description": 110,
	"admin_email": 121,
	"admin_phone": 130,

	// billing stuff
	"country": 211,
	"state": 221,
	"city": 231,
	"address": 240,			// need this for billing
	"master_key": 253,		// fixed document ID for master accounts

	"id": 1010,			// firebase ID
	"created": 1020,		// creation date
	"lat": 1030,
	"lng": 1040,
	"admin_id": 1050,
	"master_id": 1060,		// owned by master acount - default to axos, also serves as security
	"hash": 2000,			// <country>-<city>-<name_hash>-<cnt>
	"timestamp": 2010,
}


// group object for initialization
//     - an group is a organization container, a subdivision
//     - groups be a multi-layers deep to fit classification needs
//     - can be used for teams in a club, a group of friend, or anything
//     - parent can [ org, player, group ]
//
const GroupObj = {
	"key": 15,			// easy 4 letter shorthand for admin
	"name": 21,			// human readable title
	"notes": 30,			// for owner
	"type": 42,			// [ team, group, 
	"subtype": 52,			// [ team, group, 
	"seq": 81,			// sequence within program, orig step by 1000, each add splits it, support 10 adds
	"public": 91,			// searchable in a directory
    "invite_key": 100,      // <key>+<create_date_hash>  use for invite

	"description": 110,
	"owner_hash": 121,    // could be owned by a group, user or org (top level group)
	"owner_email": 140,

	"start_date": 140,  // For "class" type: "YYYYMMDD"
	"start_time": 140,  // in 24 hour (hhmm)
	"duration": 140,    // in min

	"id": 1010,			// firebase ID
	"created": 1020,		// creation date
	"lat": 1030,
	"lng": 1040,
	"org_key": 1050,		// owner of this sequence
	"org_id": 1054,		    // owner of this sequence
	"owner_id": 1060,      // for validation [user_id, org_id]
	//"admin_id": 1050,
	"hash": 2000,			// <country>-<city>-<name_hash>-<cnt>
	"timestamp": 2010,
}


// player object for initialization
//     - every player has a record
//     - example: renegade, 
//     - a vendor can also be an org (to have players)
//     - every org need to have a vendor, default is axos
//     - default org is axos, if not part of a group
//
const UserObj = {
	"email": 11,
	"name": 21,			// human readable title
	"notes": 30,			// for owner
	"type": 42,			// [player, admin, god]

	"phone": 120,
	"avatar": 131,
	"age": 140,
	"height": 150,
	"tag": 150,         // for searching
    "language": 160,    // preferred language [en, es, ch...]
    "invite_key": 170,      // passed in from the link, encrypted "create_date+<4_char>"

	"country": 210,
	"state": 220,
	"city": 230,
    "tz_offset": 240,      //new Date().getTimezoneOffset();   in minutes from UTC (UTC+1 == -60, PST == UTC-7 == +(60 *7))
	"auth": 260,			// JWT if is god
	"anon": 270,			// if temp anon account, placehold to track user before proper login
	"test": 280,			// if test account, it can not set new records
	// stats    << TBD, summary updated per day by daemon for easy look up

	"id": 1010,			// firebase ID
	"created": 1020,		// creation date
	"key": 1035,		// email.replace("@", ".") => ("_"), key can not change, email CAN
    "user_state": 1140,
	"firebase_uid": 1160,   // for retrieving firestore auth record
	"home_org_id": 1170,         // need this for future multi-tenancy
	"home_org_key": 1180,        // need this for quick lookup

	"lat": 1530,			// KEY: extract geo affiliation from this, not address
	"lng": 1540,
	"hash": 2000,			// usr-"key"    ; independent of org, so smae account can subscribe across orgs
	"timestamp": 2010,
}


// msg object for bot master-slave communication
//     - remote control of bots for clinics
//     - Feedback can have links to videos
//     - Bot control has info to execute the next step
//     - NOTE: store user_hash in field to avoid search?
//
const MsgObj = {
	"type": 100,			// [bot, ...]
	"subtype": 110,			// [setup, start, abort]
	"mode": 115,			// [prog, drill]
	"class_name": 120,
    "to_hash": 130,
	"group_id": 140,        // important to tie all msgs related to this session

    "drill_hash": 205,
	"devices_hash": 210,
	"prog_hash": 220,
    "from_hash": 1400,
	//"content": 225,	
	"users_hash": 230,	
	"all_users": 240,		// hold object of all users in this class
	"users": 260,			// holds all users assigned to this to_hash (device)
	"stats": 250,			// all stats belong to this drill

	"id": 1000,
	"date": 1200,
	"created": 1100,
	"timestamp": 1500,
}



// Simulation Detection Instructions
//      - GENERATED FROM UI - NOT EDITED MANUALLY IN XLS!!!
//      - Associate by "v:<vimeo_id>" or "y:<youtube_id>"
//      - each <video_id> + <detect_mode> has a table entry
//      - each entry has array of detects:   detects = [detect_run]
//      - each detects has array of points:  detect_run = [detect_points]
//
const DetectsObj = {
	"video_id": 15,			// links to the video, meta data to run simulation mode
    "src": 20,              // [vimeo, youtube]
	"mode": 30,             // [target, defend, path, position, ]
	"detects": 112,		    // array of [detectRunObj] => detectRunObj = [detectPointObj]

	"footage_id": 1010,		 // points to the footage entry for quick access
}

const DetectRunObj = {
    "mode": 10,
    "start": 20,            // in seconds
    "end": 30,              // in seconds
    "points": 50,           // array of detect points:  [detectPointObj]
}

const DetectPointObj = {
    "node": 10,         // [start, target0, target1 ]
    "time": 15,
    "x": 20,
    "y": 30,
}



/////////////////////////////////////////////////////////////////////
//   ********* LIST DISPLAY SECTION ***********
//

// Footage for Simulation Drill
//      - All footage sequqnced by timestamp
//      - Annotation are done in time sequence
//
const FootageObj = {
	"video_id": 10,         // id at the source
	"source": 15,           // [vimeo, youtube, ... ]
	"title": 18,           // [drill_key, readable stuff]
	"enabled": 20,          // in-use for production
	"completed": 25,        // no more work needed, do not show in edit list
	"notes": 30,           // [vimeo, youtube, ... ]
	"group": 35,            // for organization when there are lots of videos
	"type": 40,             // [vimeo, youtube, ... ]
	"subtype": 45,            // for age, league, ...
	"tag1": 48,             // for searching and grouping
	"tag2": 48,             // for searching and grouping
	"level": 50,           // [gold, silver, bronz]
	"age": 55,             // [U14, U13,, ...]
	"start": 100,            // usable starting footage in seconds
	"end": 110,              // usable starting footage in seconds
	"duration": 120,         // film duration in seconds
	"width": 130,          // 
	"height": 140,         // 

    "editor": 200,          // email of editor who is making a change
	"uploader": 250,         // original uploader email

	"id": 1000,		        // 
	"hash": 1010,		    // array of [detectRunObj] => detectRunObj = [detectPointObj]
	"created": 1020,		// creation date
	"timestamp": 2010,
	"timeline": 2200,       // use for sequencing, if xls has nothing then autofill with created
}


// roster object for user list formating
//     - reads from users table
//     - display in row format....auto-gen start at col 100
//
const RosterObj = {
	"name": 21,			// human readable title
	"type": 42,			// [player, admin, god]
    "user_state": 52,

	"email": 111,
	"phone": 120,
	"age": 140,
	"program_hash": 140,
	"notes": 150,			// for owner
	"key": 165,			// could be email or phone, key can not change, email CAN

	"id": 5020,			// firebase ID
	"firebase_uid": 5025,   // for retrieving firestore auth record
	"created": 5030,		// creation date
	"home_org_id": 5040,         // need this for future multi-tenancy
	"home_org_key": 5050,        // need this for quick lookup
	"auth": 5140,			// JWT if is god
	"test": 5160,			// JWT if is god
	"anon": 5180,			// JWT if is god
	"hash": 5600,			// <org_key>-"key"
	"timestamp": 5610,
}





// stats bject for initialization
//     - used to track high scores, across region, and per player
//     - use  { "lat-lng1": <dist1>,  "lat-lng2": <dist2> } for quick coord association
//     - The field index is rounded up lat & lng to form "squares" for quick match
//
const StatObj = {
	// info
    "drill": 12,        // drill_hash
	"key": 25,			// 
    "type": 32,         //
    "target": 42,       
    "user_id": 52,          // player that made the record
    "user_avatar": 62,          // player that made the record
    "user_name": 72,          // player that made the record
    "cluster_hash": 82,       // scope cluster: [ org, group, geo]
    "session_id": 91,

    "r00": 312,
    "r01": 322,
    "r01_tot": 332,
    "r04": 342,
    "r04_tot": 352,
    "a04": 362,
    "a04_tot": 372,
    "r05": 410,
    "r05_tot": 420,
    "a05": 430,
    "a05_tot": 440,
    "t00": 800,
    "t00_tot": 810,
    "t01": 820,
    "tt0": 830,

    // geo locator
    "id": 5012,
    "hash": 5022,           // <drill_hash>+<target>
    //"country": 5212,
    //"state": 5222, 
    //"msa": 5232,   
    //"county": 5242, 
    //"city": 5252,   
	"timestamp": 5310,
}



// object auxiliary info for initialization
//     - maintains STATE info (fields of data)
//     - any entity can have a state object (user, org, group)
//     - this is the "tow-behind" container that keeps all the infrequently used data
//
const AuxObj = {
	// info
	"owner_hash": 15,	//  [ user, prog, org, group, ]
	"type": 42,			// types of info: [ tutorial, score, leader ]
	"subtype": 52,		// subtypes: [ daily_socre, ... ]
	"state": 60,		// [ "archived"]
	"start_timestamp": 80,
	"start_day": 90,

	"id": 1010,			// firebase ID
	"created": 1040,		// creation date
	"owner_id": 2030,      // for validation [ org_id, user_id ]
	"hash": 2040,			// aux-<type>-<owner_hash>
	"timestamp": 2050,

    // lots of fields   e.g.  <tut_hash>: <last_read_date>
}


/*   RE-USE CONTENT TABLE
//
// splashes info
// CAN WE REUSE CONTENT FOR THIS?
//     - powers custom splash pages
const SplashObj = {
    "key": 10,          // easy 6 letter shorthand for admin
	"owner_hash": 14,		// e.g. player_hash, org_hash, prog_hash
	"name": 21,			// human readable title
	"version": 41,
	"notes": 50,			// for owner
	"owner_id": 200,		// [ org_id, user_id ]
    //"invite_hash": 100,     // NO, could be tied to multiple invites!

    // content
    "image": 400,

    // autogen
	"id": 5010,			// firebase ID
	"created": 5020,		// creation date
	"org_key": 5030,		// owner of this sequence       // VERY SENSITIVE SEQUENCE!  org_key on TOP
	"org_id": 5040,			// owner of this sequence
	"hash": 5060,			// <org_key>-<key>-<ver>
	"timestamp": 5070,
}
*/


// score - AUXS OBJECT DEF - FOR DOCUMENTATION
//     - contains scores, which goes into the leader board
//     - store in AuxObj:  {type = "score", data = { epoch_day: score } }
//     - 
//     - use timestamp to tie with score source
//
const ScoreObj = {
    "drill_hash": 112,       
    "target": 122,       
    "score": 132, 
    "type": 142,            // score
    "subtype": 152,         //  [ session_score, daly_score ]

    "session_id": 222,        
	"timestamp": 235,		// 
    "epoch_day": 245,       // days since epoch, adjust for local time
	"user_id": 315,			// player that made the record
	"user_avatar": 325,		// 
	"user_name": 335,		// 
	"video_link": 345,		// 

    "<session_timestamp>": [    // score of each session
    //{
        //"drill_hash": 
        //"base": 
        //"pbonus": 
        //"lbonus": 
        //"epoch_day": 
        //"epoch_week": 
        //"score": 
        //"timestamp": 
    //}
    ]

}



// leader board - AUXS OBJECT DEF - FOR DOCUMENTATION
//     - contains ranked players, for each geo, group, parent_group, org, 
//     - store in AuxObj:  {type = "leader", data = { <user_id>: {score} } }
//     - 
//     - use timestamp to tie with score source
//
const LeaderObj = {
    "drill_hash": 112,       
    "target": 122,       
    "score": 132, 
    "type": 142,            // leader
    "subtype": 152,         //  [ session_score, daly_score ]

    "session_id": 222,        
	"timestamp": 235,		// 
    "epoch_day": 245,       // days since epoch, adjust for local time
	"user_id": 315,			// player that made the record
	"user_avatar": 325,		// 
	"user_name": 335,		// 
	"video_link": 345,		// 

    "players": [    // score of each session
    //{
    //}
    ]
}







// NOTE: DON'T THINK WE NEED THIS...JUST USE SESSION
//
// score_source - AUXS OBJECT DEF - FOR DOCUMENTATION
//     - per player, contains relevant metrics extracted from each session
//     - store in AuxObj:  {type = "score_source", data = { timestamp: [scoreSourceObj]} }] }
//     - this holds session summary, so we can very quickly regenerate scores for the leaderboard
//     - use timestamp to tie with score
/*
const ScoreSourceObj = {
    "drill_hash": 112,       
    "session_id": 12,        
	"timestamp": 25,			// 
    "type": 32,         //
    "target": 42,       
    "user_id": 52,          // player that made the record

} */


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// INTERNAL EXECUTION STATES (NO XLS)
//

//
// NO-XLS: run related info
//
const RunObj = {
	"id": null,		// 
	"ctr_x": null,		// in pixels
	"ctr_y": null,
	"_id": null,		// 
}


// NO-XLS:
const TurnObj = {
	"type": null,		// "ball" or "pose"
	"time": null,		// msec of event
	"rtime": null,		// delta msec from last turn
	"degree": null,
	"ddegree": null,	// change in degree from last turn
	"dist": null,		// pix distance traveled since last turn
	"pbdist": null,		// pose to ball distance to assess ball control
	"last_turn": null,	// hidx of this turn
	"_id": null,		// 
}


// NO-XLS: persistent session (real or fake) cone states, used to run the session
//

// cone base object for initialization
//
const ConeObj = {
	// processed cones for actual use
	"id": null,			// "ctr_x"+"ctr_y"+"width"
	"_id": null,			// "ctr_x"+"ctr_y"+"width"
	"ctr_x": null,		// in pixels
	"ctr_y": null,
	"ctr_by": null,
	"width": null,
	"height": null,
	"prob": null,		// in 100
	"dy": 0,			// for height box calculation at cone

	"display": null,	// could be null, target, success, fail
	"locked": false,	// in-use, can not be deleted
	"fake": false,		// artificial cone
	//"phantom": false,	// intermediate node for unscheduled turns
	"home": false,		// holder of home zone
	"show_person": false,	// show person outline for calibration
	"phantom": false,		// phatom marker for progress checking and audible reverse
	"phantom_id": null,	// has phantom child 

	"valid_cnt": null,	// validity count
	"valid": false,		// false if bad bounding box
	"verified": false,	// true if manually verified
	"veri_cnt": 0,		// count for numb times verified
	"tmp": 0,			// internal use for detect deletion
}


// NO-XLS: session object for initialization
//
const SessionObj = {
    "id": 123,              // firebase assigned ID
    "avos_version": 111,    // base sw version
    "version": 111,         // schema of this session obj
    "date": 100,            // human readable
    "timestamp": 111,       // epoch msec
    "user_id": 22,          // user key: "clark:gmail_com"
    "firebase_uid": 222,             // firebase user id
    "user_location": 12,    // <
    "user_agent": 1,
    "device_type": 1,
    "bug_report": 1,

    // drill related
    "name": null,            // drill name for human
    "drill_hash": null,      // "drl:axos:marad:1",
    "type": null,            // [ perf, game, drill ]
    "mode": null,            // [ student, test ]
    "console": null,         // pointer to console log bucket
    "video": null,           // vimeo video link
    "frames": null,            // pointer to history frame bucket
    "frame_count": null,

    // perf params - MUST BE 3 chars and end with a digit
    "ss0": null,
    "ss0_cnt": null,
    "tt0": null,

    // new
    "tz_offset": -420,      //new Date().getTimezoneOffset();   in minutes from UTC (UTC+1 == -60, PST == UTC-7 == +(60 *7))
    "completed": true,
    "test": null,
}


// NO-XLS: frame history object for initialization
//    - IMPORTANT: MUST SEED THIS OBJECT FOR ANY NEW HISTORY[X].*!!!
//
const FrameHistoryObj = {
	"_id": null,
	"timestamp": null,	// actual raw msec
	"timestamp_show": null,		// displayable time stamp
	"events": [],	// something happened at this frame
	"ball": {
		"name": "ball",
		"x0": null,		// in pixels
		"y0": null,
		"x1": null,
		"y1": null,
		"ctr_x": null,
		"ctr_y": null,
		"ctr_x0": null,		// orig
		"ctr_y0": null,		// orig
		"ctr_by": null,	// birds eye Y
		"bb_x": null,	// bounding box width
		"bb_y": null,	// bounding box height
		"prob": null,	// in 100
		"valid": false,		// false if bad bounding box
	},
	"cones": [],		// see ConeObj
	"pose": {
		"valid": false,		// false if bad pose
		"keypoints": null,
		"eyes_width": 0,	// eyes width, kids = 5cm, adult = 6cm
		"eyes_prob": 0,		// confidence of raw eye width in 100
		"head_width": 0,	// ear width, kids = 55cm, adult = 60cm
		"head_prob": 0,		// confidence of raw ear width in 100
		"femur_length": 0,	// determined statistically
		"femur_length0": 0,	// raw femur bone, kids avg 38 cm, adult avg 48 cm
		"femur_prob": 0,	// confidence of raw eye width in 100
		"hip_width": 0,		// hip width
		"hip_prob": 0,		// confidence of raw hip width in 100
		"ctr_x": null,		// center of the hip, use to this to fix body position
		"ctr_y": null,
		"ctr_x0": null,		// orig
		"ctr_y0": null,		// orig
		"ctr_by": null,		// birds eye Y (transformed)
		"top": 0,			// tip of the head in Y px
		"bottom": 0,		// lowest ankel in Y px
		"bottom0": 0,		// for expon smooth
		"left": 0,			// left ankel in Y px
		"right": 0,			// right ankel in Y px
		"height": 0,		// pixels to the bottom of the ankle
	},
	"stats": {
		"ball_w": null,		// ball width in pixles, 22 cm
		"ball_prob": 0,		// confidence of ball width
		"body_w": null,		// body width (11.left_hip - 12.rihgt_hip) in pixles
		"body_prob": 0,		// confidence of body width
		"pixel_ratio": null,	// convert ratio to ft, based on eyes, hips and ball
		"ref_y": null,			// reference Y location where the pixel_ratio is valid
		"ref_femur": null,		// reference femur length at ref_y
		"ratio_femur_y": null,		// slope of D-femur v D-Y, use to calc depth
	},
	"position": {
		"lfoot_2ball": 0,	// pixels of left foot to ball center
		"rfoot_2ball": 0,	// pixels of right foot to ball center
	},
	"defender": {
		"type": null,		// version of image
		"top": 500,		// top of the image
		"left": 0,		// left of the image
		"height": 0,		// image height
		"width": 0,		// image width
	},
    "markers": [],      // limb markers from 3D positions [TL, TR, BL, BR, CH]
	"trail3d": {
        "slarm": 0,
        "slfam": 0,
        "srarm": 0,
        "srfam": 0,
        "slthg": 0,
        "slleg": 0,
        "srthg": 0,
        "srleg": 0,
        "sched": 0,

        "tlarm": 0,
        "tlfam": 0,
        "trarm": 0,
        "trfam": 0,
        "tlthg": 0,
        "tlleg": 0,
        "trthg": 0,
        "trleg": 0,
        "tched": 0,
    },
	"trail": {
		"bx": null,			// ball ready-to-display motion trail info
		"by": null,			// 
		"bx0": null,		// original
		"by0": null,		// original
		"bdist": 0,		// distance from last frame
		"bdist1": 0,		// cum distance in this direction
		"bdegree": null,	// reaadusted degree
		"bdegree0": null,	// original degree
		"bspeed": 0,		// 
		"bspeed0": 0,		// original speed
		"bflip": false,		// chnage in ball direction
		"bvalid": null,		// only can valid afte the 3rd frame

		"bbasex": 0,		// start coord of current direction
		"bbasey": 0,
		"btargx": 0,		// projected target x at current vector
		"btargy": 0,
		"btargdist": 0,		// current distance to target
		"botargdist": 0,		// current distance to target
		"btargdegree": 0,	// current distance to target
		"breverse": 0,		// conseq reverse count

		"px": null,			// pose - ready-to-display motion trail info
		"py": null,			// 
		"px0": null,			// pose - ready-to-display motion trail info
		"py0": null,			// 
		"pdist": 0,		// 
		"pdist1": 0,		// cum distance in this direction
		"pdegree": null,	// reaadusted degree
		"pdegree0": null,	// original degree
		"pspeed": 0,		// REF: Walking is 5 ft/sec, Fast run is 22 ft/sec, fastest SPRINT is 32 ft/sec
		"pspeed0": 0,		// original speed
		"pflip": false,		// chnage in body direction
		"pvalid": null,		// only can valid afte the 3rd frame

		"pbasex": 0,		// start coord of current direction
		"pbasey": 0,
		"ptargx": 0,		// projected target x at current vector
		"ptargy": 0,
		"ptargdist": 0,		// current distance to target
		"potargdist": 0,		// current distance to target
		"ptargdegree": 0,	// current distance to target
		"preverse": 0,		// conseq reverse count

		"start": false,		// start of a segment
	},
	"action": {
		"delta_x": null,	// speed
		"delta_y": null,	// speed
		"flipx": false,		// verified a chg in x direction (a touch)
		"flipy": false,		// verified a chg in y direction (a touch)
		"touch_time": null,	// msec since last touch

		"ball_speed": 0,	// ball center movement
		"body_speed": 0,	// body center movement fs/sec => 22 ft/s = 15 Mi/Hr => 4 min/Mi  *** VERY FAST RUN
		"defend_speed": 0,	// pixel per sec of defender center movement

		"ball_dir": 0,		// 1=(+, +), 2=(+, 0), 3=(+, -), 4=(0, -), 5=(-, -), 6=(-, 0), 7=(-, +), 8=(0, -)
		"body_dir": 0,		// 1=(+, +), 2=(+, 0), 3=(+, -), 4=(0, -), 5=(-, -), 6=(-, 0), 7=(-, +), 8=(0, -)
		"defend_dir": 0,	// 1=(+, +), 2=(+, 0), 3=(+, -), 4=(0, -), 5=(-, -), 6=(-, 0), 7=(-, +), 8=(0, -)

		"ball_degree": 0,	// direction in degrees
		"body_degree": 0,	// direction in degrees
		"defend_degree": 0,	// direction in degrees

		"ball_dist": 0,		// last distance moved in pixel
		"body_dist": 0,		// last distance moved in pixel
		"defend_dist": 0,	// last distance moved in pixel
		"defend_tdist": 0,	// player distance since last turn

        "cont_ball_dist": 0,    // ball travel in same direction across frames, use this for reaction time calc
		"goal_dx": 0,		// x distance to goal
		"goal_dy": 0,		// y distance to goal
		"goal_dist": 0,		// distance to goal
	},
}



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// INTERNAL EXECUTION STATES (NO XLS)
//

// for analyzing turns based on 2D body position 
// 
// NOTE: Add custom data load code in populateSessions()
//
const PerfTurns2DObj = {
    "time_show": 100,
    "dt": 110,
    "event": 120,
    "hidx": 130,
    "time": 140,
    "tball.valid": 210,
    "t.bx": 220,
    "t.by": 230,
    "t.bdist": 240,
    "t.bspeed": 250,
    "t.bdegree": 260,
    "t.bflip": 270,
    "tpose.valid": 280,

    "t.px": 310,
    "t.py": 320,
    "t.pdist": 330,
    "t.pspeed": 340,
    "t.pdegree": 350,
    "t.pflip": 360,

    "b.ctr_x": 410,
    "b.ctr_y": 420,
    "p.ctr_x": 430,
    "p.ctr_y": 440,
    "b.ctr_x0": 450,
    "b.ctr_y0": 460,
    "p.ctr_x0": 470,
    "p.ctr_y0": 480,

    "bdeg0": 510,
    "pdeg0": 520,
    "bspd0": 530,
    "pspd0": 540,

    "px_rat": 610,
    "ref_y": 620,
    "ref_fmr": 620,
    "fmr_rat": 630,
    "g.dx": 1010,
    "g.dy": 1020,
    "g.dist": 1030,
    "p.top": 1040,
    "p.bot": 1050,

    "t.pbx": 1110,
    "t.pby": 1120,
    "t.ptx": 1130,
    "t.pty": 1140,
    "t.ptodist": 1150,
    "t.ptdist": 1160,
    "t.ptdgr": 1170,
    "t.prev": 1180,
}



// change of direction study
//    - accelration rate
//    - defender behavior
//
const CODObj = {
    "time_show": 100,
    "dt": 110,
    "event": 120,
    "hidx": 130,
    "time": 140,
    "tball.valid": 210,
    "t.bx": 220,
    "t.by": 230,
    "t.bdist": 240,
    "t.bspeed": 250,
    "t.bdegree": 260,
    "t.bflip": 270,
    "tpose.valid": 280,

    "t.px": 310,
    "t.py": 320,
    "t.pdist": 330,
    "t.pspeed": 340,
    "t.pdegree": 350,
    "t.pflip": 360,

    "b.ctr_x": 410,
    "b.ctr_y": 420,
    "p.ctr_x": 430,
    "p.ctr_y": 440,
    "b.ctr_x0": 450,
    "b.ctr_y0": 460,
    "p.ctr_x0": 470,
    "p.ctr_y0": 480,

    "bdeg0": 510,
    "pdeg0": 520,
    "bspd0": 530,
    "pspd0": 540,

    "px_rat": 610,
    "ref_y": 620,
    "ref_fmr": 620,
    "fmr_rat": 630,
    "g.dx": 1010,
    "g.dy": 1020,
    "g.dist": 1030,
    "p.top": 1040,
    "p.bot": 1050,

    "t.pbx": 1110,
    "t.pby": 1120,
    "t.ptx": 1130,
    "t.pty": 1140,

    // defender here  (action)
    "d.type": 2000,
    "d.top": 2100,
    "d.lft": 2200,
    "d.ht": 2300,
    "d.wd ": 2400,

    "a.bspd0": 3100,     // "a.dspd"
    "a.bspd": 3200,      // "a.dtspd"
    "a.dtdist": 3250,
    "a.ddist": 3300,
    "a.ddgr": 3400,
    "a.ddxps": 3500,
    "a.drst": 3600,
    "a.gvup": 3700,

    // debug
    "ref_fmr0": 5000,
}



// for detecting pose using 3D vectors
//
// NOTE: Add custom data load code in populateSessions()
//
const PerfPose3DObj = {
    "time_show": 100,
    "dt": 110,
    "event": 120,
    "hidx": 130,
    "time": 140,

    "larm.deg": 200,
    "lfam.deg": 210,
    "rarm.deg": 220,
    "rfam.deg": 230,
    "lthg.deg": 240,
    "lleg.deg": 250,
    "rthg.deg": 260,
    "rleg.deg": 270,
    "ched.deg": 280,

    "t.px": 290,
    "t.py": 295,

    "larm.xd": 300,
    "larm.yd": 310,
    "larm.zd": 320,

    "rarm.xd": 340,
    "rarm.yd": 370,
    "rarm.zd": 380,

    "lfam.xd": 440,
    "lfam.yd": 470,
    "lfam.zd": 480,

    "rfam.xd": 550,
    "rfam.yd": 570,
    "rfam.zd": 580,

    "lthg.xd": 640,
    "lthg.yd": 670,
    "lthg.zd": 680,

    "rthg.xd": 740,
    "rthg.yd": 770,
    "rthg.zd": 780,

    "lleg.xd": 840,
    "lleg.yd": 870,
    "lleg.zd": 880,

    "rleg.xd": 910,
    "rleg.yd": 920,
    "rleg.zd": 930,

    "ched.xd": 950,
    "ched.yd": 960,
    "ched.zd": 970,
}

// for detecting pose using 3D vectors
//
// NOTE: Add custom data load code in populateSessions()
//
const PerfMarker3DObj = {
    "time_show": 100,
    "dt": 110,
    "event": 120,
    "hidx": 130,
    "time": 140,

    "larm.deg": 200,
    "lfam.deg": 210,
    "rarm.deg": 220,
    "rfam.deg": 230,
    "lthg.deg": 240,
    "lleg.deg": 250,
    "rthg.deg": 260,
    "rleg.deg": 270,
    "ched.deg": 280,

    "t.px": 290,
    "t.py": 295,

    "larm.xd": 300,
    "larm.yd": 310,

    "TL.tokn": 1000,
    "TL.memb": 1005,
    "TL.amx1": 1010,
    "TL.adl1": 1020,
    "TL.amx2": 1030,
    "TL.adl2": 1040,
    "TL.tdel": 1050,

    "TR.tokn": 2000,
    "TR.memb": 2005,
    "TR.amx1": 2010,
    "TR.adl1": 2020,
    "TR.amx2": 2030,
    "TR.adl2": 2040,
    "TR.tdel": 2050,

    "BL.tokn": 3000,
    "BL.memb": 3005,
    "BL.amx1": 3010,
    "BL.adl1": 3020,
    "BL.amx2": 3030,
    "BL.adl2": 3040,
    "BL.tdel": 3050,

    "BR.tokn": 4000,
    "BR.memb": 4005,
    "BR.amx1": 4010,
    "BR.adl1": 4020,
    "BR.amx2": 4030,
    "BR.adl2": 4040,
    "BR.tdel": 4050,

    "CH.tokn": 5000,
    "CH.memb": 5005,
    "CH.amx1": 5010,
    "CH.adl1": 5020,
    "CH.amx2": 5030,
    "CH.adl2": 5040,
    "CH.tdel": 5050,

    "arm.tokens": 6000,
    "leg.tokens": 6100,
}


const Perf3DKeypointsObj = {
    "time_show": 100,
    "dt": 110,
    "event": 120,
    "hidx": 130,
    "time": 140,
    "lear.x": 200,
    "lear.y": 210,
    "lear.z": 230,
    "rear.x": 240,
    "rear.y": 250,
    "rear.z": 260,
    "nose.x": 300,
    "nose.y": 310,
    "nose.z": 320,
    "lhip.x": 410,
    "lhip.y": 420,
    "lhip.z": 430,
    "rhip.x": 440,
    "rhip.y": 450,
    "rhip.z": 460,
    "lsho.x": 500,
    "lsho.y": 510,
    "lsho.z": 520,
    "lelb.x": 530,
    "lelb.y": 540,
    "lelb.z": 550,
    "lwrs.x": 600,
    "lwrs.y": 610,
    "lwrs.z": 620,
    "rsho.x": 630,
    "rsho.y": 640,
    "rsho.z": 650,
    "relb.x": 700,
    "relb.y": 710,
    "relb.z": 720,
    "rwrs.x": 730,
    "rwrs.y": 740,
    "rwrs.z": 750,
}

// XLS: IDX-* SESSION LIST for analyzing scoring based on perf metrics
//
//    - ALSO LINKED AS  aps/axo-template.js!!!
// 
const PerfSessionIndexObj = {
    "cmd": 10,
    //"email": 20,
    "user_key": 20,     // user key (email)
    "timestamp": 30,
    "name": 40,
    "keep": 45,
    "tag": 50,
    "comment": 60,
    "bug_report": 70,
    "skip": 80,     // use this skip session for Leader
    "type": 100,
    "mode": 110,
    "uid": 140,   // firebase user id
    "sid": 150,    // session id
    "dtime": 160,
    "f_cnt": 210,
    "frame": 220,
    "video": 230,
    "console": 240,
    "device": 250,
    "location": 310,
    "version": 320,
    "ss0": 1000,
    "r04": 1050,
    "t04": 1100,
    "c01": 1140,
    "a04": 1200,
    "r00": 1300,
    "r01": 1400,
    "t00": 1500,
    "t01": 1600,
    "tt0": 1700,
    "bonus": 1800,
    "exp": 1900,
}

// NOT MUCH USED: OLD Turning point analysis
//
const PerfBaseRunObj = {
    "run": 10,
    "time": 20,
    "timestamp": 30,
    "hidx": 40,
    "type": 50,
    "dtime": 100,
    "x": 120,
    "y": 130,
    "degree": 140,
    "ddegree": 150,
    "dist": 160,
}



// KLUDGE: in APS need to define a stub: module{export: null} so this file works
module.exports =  { RunObj, TurnObj, ConeObj,
			FrameHistoryObj, MembershipObj, ProgramObj,
			SequenceObj, MenuObj, SectionObj, DrillObj,
			OrgObj, UserObj, MotionObj, GroupObj, MsgObj,
            RosterObj, AuxObj, ContentObj, LinkObj, FootageObj, 
            PerfSessionIndexObj, PerfBaseRunObj, PerfTurns2DObj,
            Perf3DKeypointsObj,PerfPose3DObj,
			}